import * as React from "react"
import compose from "recompose/compose"
import getContext from "recompose/getContext"
import withContext from "recompose/withContext"
import withHandlers from "recompose/withHandlers"
import withState from "recompose/withState"
import withProps from "recompose/withProps"
import PropTypes from "prop-types"
import { FencingLightbox } from "@/components"

const LightboxContainer = getContext({
  openLightbox: PropTypes.func,
})(({ lightbox: Lightbox, lightboxProps, openLightbox }) => (
  <Lightbox
    visible
    onClose={() => openLightbox({ name: null, props: {} })}
    {...lightboxProps}
  />
))

const LightboxProvider = compose(
  withState("lightbox", "setLightbox", {
    name: null,
    props: {},
    component: null,
  }),
  withHandlers({
    openLightbox: ({ setLightbox }) => ({ name, component, props }) => {
      setLightbox({ name, component, props })
    },
  }),
  withContext(
    {
      openLightbox: PropTypes.func,
    },
    ({ openLightbox }) => ({ openLightbox }),
  ),
)(({ lightbox, children }) => {
  const lightboxes = {
    fencing: FencingLightbox,
  }

  const LightboxComponent = !!lightbox.component
    ? lightbox.component
    : lightboxes[lightbox.name]

  return (
    <React.Fragment>
      {LightboxComponent && (
        <LightboxContainer
          lightbox={LightboxComponent}
          lightboxProps={lightbox.props}
        />
      )}
      {React.Children.only(children)}
    </React.Fragment>
  )
})

export const withLightboxTrigger = (
  lightbox,
  lightboxProps = {},
  track = () => {},
) =>
  compose(
    getContext({
      openLightbox: PropTypes.func,
    }),
    withProps(({ product, openLightbox, trackAction }) => ({
      openLightbox: () => {
        const lightboxIsComponent = typeof lightbox === "function"
        const name = lightboxIsComponent ? undefined : lightbox
        const component = lightboxIsComponent ? lightbox : undefined

        openLightbox({ name, component, props: { product, ...lightboxProps } })
        track(trackAction)
      },
    })),
  )

export default LightboxProvider
